export const environment = {
  production: true,
  buildVersion: "__BUILD_VERSION__",
  baseUrl: "https://app.astrobin.com",
  classicBaseUrl: "https://www.astrobin.com",
  classicApiUrl: "https://app.astrobin.com", // Proxied by node (see: server.ts)
  cdnUrl: "https://cdn.astrobin.com",
  wsUrl: "wss://www.astrobin.com",
  sentryKeys: ["8284df973c49473baa2c08d8212fcde6", "o4503907479519232", "4503907484237824"],
  // Bump this number to invalidate the cache of the CKEditor
  ckeditorTimestamp: "20250724.1",
  authSessionTimeout: 1200,
  enableDebugAuth: false,
  turnstileSiteKey: "0x4AAAAAAA81Q5_THN3cKjKR"
};
